import { render } from "./DoctorServiceReportOld.vue?vue&type=template&id=7b05c3ab&scoped=true"
import script from "./DoctorServiceReportOld.vue?vue&type=script&lang=js"
export * from "./DoctorServiceReportOld.vue?vue&type=script&lang=js"

import "./DoctorServiceReportOld.vue?vue&type=style&index=0&id=7b05c3ab&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b05c3ab"]])

export default __exports__